import Head from 'next/head'
import shopInfos from 'template/infos'
const { name, url } = shopInfos

const Seo: React.FC = () => <Head>

  <title>{`Deine Wunschliste bei ${name}`}</title>

  <meta name='description' content={
    `Deine Favoriten ganz einfach mit dem Herz-Button markieren und speichern, 
    so hast du alle Lieblingsteile auf einem Blick.`
  } />

  <link rel='canonical' href={`${url}wunschliste`} />

</Head>

export default Seo
